/* handle running in node.js */
const kIsNodeJS = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';

class WorkerPool {
    static get sharedInstance() {
        return kSharedInstance; // eslint-disable-line
    }

    constructor(workers = []) {
        this.mWorkers = workers;
        this.mIdleWorkers = [...workers];
        this.mTasks = [];
    }

    get workers() {
        return this.mWorkers;
    }

    get workerCount() {
        return this.mWorkers.length;
    }

    get tasks() {
        return this.mTasks;
    }

    get running() {
        return this.mTasks.length || this.mIdleWorkers.length !== this.mWorkers.length;
    }

    killWorkers() {
        for (let i = 0, n = this.mWorkers.length; i < n; ++i) {
            this.mWorkers[i].terminate();
        }
        this.mWorkers.length = 0;
        this.mIdleWorkers.length = 0;
    }

    scheduleTask(type, options, transferable = null) {
        return new Promise((resolve, reject) => {
            if (this.mIdleWorkers.length) {
                this._executeTask(this.mIdleWorkers.pop(), type, options, transferable, resolve, reject);
            } else {
                this.mTasks.unshift({
                    type,
                    options,
                    transferable,
                    resolve,
                    reject,
                });
            }
        });
    }

    addWorker(worker, initMessage = null) {
        this.mWorkers.push(worker);

        if (initMessage) {
            return new Promise((resolve, reject) => {
                const addListener = worker.addEventListener || worker.on;
                const removeListener = worker.removeEventListener || worker.off;

                const handler = e => {
                    const message = e.data;
                    removeListener.call(worker, 'message', handler);

                    if (message.type === 'success') {
                        this._executeTaskFromQueue(worker);
                        resolve();
                    } else if (message.type === 'error') {
                        reject(message.reason);
                    } else {
                        reject(`ERROR: Unrecognized message type sent from data worker "${message.type}"`);
                    }
                };
                addListener.call(worker, 'message', handler);
                worker.postMessage(kIsNodeJS ? { data: initMessage } : initMessage);
            });
        }

        this._executeTaskFromQueue(worker);
        return Promise.resolve();
    }

    removeWorker() {
        if (this.mIdleWorkers.length) {
            const worker = this.mIdleWorkers.pop();
            const i = this.mWorkers.indexOf(worker);
            this.mWorkers.splice(i, 1);
            return worker;
        }
        return null;
    }

    _executeTask(worker, type, options, transferable, resolve, reject) {
        const addListener = worker.addEventListener || worker.on;
        const removeListener = worker.removeEventListener || worker.off;
        const handler = e => {
            const message = e.data;
            removeListener.call(worker, 'message', handler);

            if (message.type === 'success') {
                resolve(message.data);
            } else if (message.type === 'error') {
                reject(message.reason);
            } else {
                throw `ERROR: Unrecognized message type sent from data worker "${message.type}"`;
            }

            this._executeTaskFromQueue(worker);
        };
        addListener.call(worker, 'message', handler);

        const message = {
            type,
            options,
        };
        worker.postMessage(kIsNodeJS ? { data: message } : message, transferable);
    }

    _executeTaskFromQueue(worker) {
        if (this.mTasks.length) {
            const task = this.mTasks.pop();
            this._executeTask(worker, task.type, task.options, task.transferable, task.resolve, task.reject);
        } else {
            this.mIdleWorkers.push(worker);
        }
    }
}

const kSharedInstance = new WorkerPool([]);

var kRequire =
    typeof module !== 'undefined' && typeof module.require === 'function' && module.require || // eslint-disable-line
    typeof __non_webpack_require__ === 'function' && __non_webpack_require__ || // eslint-disable-line
    typeof require === 'function' && require || // eslint-disable-line
    null; // eslint-disable-line

var WorkerClass = null;

if (kRequire) {
    try { WorkerClass = kRequire('worker_threads').Worker; } catch(e) {} // eslint-disable-line
}

function decodeBase64(base64, enableUnicode) {
    return Buffer.from(base64, 'base64').toString(enableUnicode ? 'utf16' : 'utf8');
}

function createBase64WorkerFactory(base64, sourcemapArg, enableUnicodeArg) {
    var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
    var enableUnicode = enableUnicodeArg === undefined ? false : enableUnicodeArg;
    var source = decodeBase64(base64, enableUnicode);
    var start = source.indexOf('\n', 10) + 1;
    var body = source.substring(start) + (sourcemap ? '\/\/# sourceMappingURL=' + sourcemap : '');
    return function WorkerFactory(options) {
        return new WorkerClass(body, Object.assign({}, options, { eval: true }));
    };
}

function decodeBase64$1(base64, enableUnicode) {
    var binaryString = atob(base64);
    if (enableUnicode) {
        var binaryView = new Uint8Array(binaryString.length);
        for (var i = 0, n = binaryString.length; i < n; ++i) {
            binaryView[i] = binaryString.charCodeAt(i);
        }
        return String.fromCharCode.apply(null, new Uint16Array(binaryView.buffer));
    }
    return binaryString;
}

function createBase64WorkerFactory$1(base64, sourcemapArg, enableUnicodeArg) {
    var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
    var enableUnicode = enableUnicodeArg === undefined ? false : enableUnicodeArg;
    var source = decodeBase64$1(base64, enableUnicode);
    var start = source.indexOf('\n', 10) + 1;
    var body = source.substring(start) + (sourcemap ? '\/\/# sourceMappingURL=' + sourcemap : '');
    var blob = new Blob([body], { type: 'application/javascript' });
    var url = URL.createObjectURL(blob);
    return function WorkerFactory(options) {
        return new Worker(url, options);
    };
}

const kIsNodeJS$1 = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';

function isNodeJS() {
    return kIsNodeJS$1;
}

function createBase64WorkerFactory$2(base64, sourcemapArg, enableUnicodeArg) {
    if (isNodeJS()) {
        return createBase64WorkerFactory(base64, sourcemapArg, enableUnicodeArg);
    }
    return createBase64WorkerFactory$1(base64, sourcemapArg, enableUnicodeArg);
}

var WorkerFactory = createBase64WorkerFactory$2('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', null, false);
/* eslint-enable */

const PARSING_MODE = {
    ANALYZE: 0,
    LOAD: 1,
    BINARY: 2,
};

class DataChunk {
    static fromLoadResult(result) {
        const ret = new DataChunk(null, 0, result.stats.rowCount);
        ret._handleLoadResult(result);
        ret.mLoading = Promise.resolve(result);
        return ret;
    }

    constructor(blob, columnCount, rowCount, config) {
        this.mBlob = blob;
        this.mColumnCount = columnCount;
        this.mRowCount = rowCount;
        this.mConfig = Object.assign({}, config);
        this.mBuffer = null;
        this.mView = null;

        this.mOffsetList = null;
        this.mLayout = null;
        this.mDataOffset = 0;

        this.mLoading = null;
    }

    get blob() {
        return this.mBlob;
    }

    get buffer() {
        return this.mBuffer;
    }

    get view() {
        return this.mView;
    }

    get offsetList() {
        return this.mOffsetList;
    }

    get layout() {
        return this.mLayout;
    }

    get dataOffset() {
        return this.mDataOffset;
    }

    get loaded() {
        return this.mBuffer !== null;
    }

    get loading() {
        return this.mLoading;
    }

    get rowCount() {
        return this.mRowCount;
    }

    load() {
        if (!this.mLoading) {
            const workerPool = WorkerPool.sharedInstance;
            const options = {
                linebreak: this.mConfig.linebreak.charCodeAt(0),
                separator: this.mConfig.separator.charCodeAt(0),
                qualifier: this.mConfig.qualifier.charCodeAt(0),
                columnCount: this.mColumnCount,
                mode: PARSING_MODE.LOAD,
                blob: this.mBlob,
                index: 0,
            };
            const loading = workerPool.scheduleTask('parseBlob', options).then(result => {
                if (this.mLoading === loading) {
                    this._handleLoadResult(result);
                }
                return this;
            });
            this.mLoading = loading;
        }
        return this.mLoading;
    }

    unload() {
        this.mBuffer = null;
        this.mView = null;
        this.mLoading = null;
        this.mOffsetList = null;
        this.mLayout = null;
        this.mData = null;
    }

    _handleLoadResult(result) {
        this.mBuffer = result.buffer;
        this.mView = new DataView(this.mBuffer);
        this.mOffsetList = new Uint32Array(this.mBuffer, result.header.offsetList.ptr, result.header.offsetList.length / 4);
        this.mLayout = new Uint32Array(this.mBuffer, result.header.layout.ptr, result.header.layout.length / 4);
        this.mDataOffset = result.header.data.ptr;
    }
}

function utf8ToStr(view, offset, length) {
    let result = '';
    let c;
    for (let i = 0; i < length; ++i) {
        c = view.getUint8(offset + i);
        switch (c >> 4) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                result += String.fromCharCode(c);
                break;

            case 12:
            case 13:
                // 110x xxxx   10xx xxxx
                result += String.fromCharCode(
                    ((c & 0x1F) << 6) |
                    (view.getUint8(offset + (++i)) & 0x3F),
                );
                break;

            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                result += String.fromCharCode(
                    ((c & 0x0F)) << 12 |
                    ((view.getUint8(offset + (++i)) & 0x3F) << 6) |
                    (view.getUint8(offset + (++i)) & 0x3F),
                );
                break;

            case 15:
                // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
                result += String.fromCodePoint(
                    ((c & 0x07) << 18) |
                    ((view.getUint8(offset + (++i)) & 0x3F) << 12) |
                    ((view.getUint8(offset + (++i)) & 0x3F) << 6) |
                    (view.getUint8(offset + (++i)) & 0x3F));
                break;
        }
    }
    return result;
}

function utf16ToStr(view, offset, length) {
    let result = '';
    for (let i = 0; i < length; ++i) {
        result += String.fromCharCode(view.getUint8(offset + i));
    }
    return result;
}

function getDecoder(encoding) {
    const lc = encoding.toLowerCase();
    switch (lc) {
        case 'unicode-1-1-utf-8':
        case 'utf-8':
        case 'utf8':
            return utf8ToStr;

        case 'utf-16':
        case 'utf16':
        case 'utf-16le':
            return utf16ToStr;

        default: {
            const decoder = new TextDecoder(lc);
            return (view, offset, length) => decoder.decode(new Uint8Array(view.buffer, offset, length));
        }
    }
}

const RowStatus = {
    ROW_STATUS_OK: 0,
    ROW_STATUS_DANGLING_QUALIFIER: 1,
    ROW_STATUS_COLUMN_MISMATCH: 2,
    ROW_STATUS_CELL_PARSING_FAILED: 4,
};

class Row {
    static get states() {
        return RowStatus;
    }

    constructor() {
        this.mIndex = -1;
        this.mChunk = null;
        this.mGetters = null;

        this.mRowOffset = 0;
        this.mRowColumnCount = 0;
        this.mRowStatus = RowStatus.ROW_STATUS_OK;
    }

    get status() {
        return this.mRowStatus;
    }

    get statusDanglingQualifier() {
        return this.hasStatus(RowStatus.ROW_STATUS_DANGLING_QUALIFIER);
    }

    get statusColumnMismatch() {
        return this.hasStatus(RowStatus.ROW_STATUS_COLUMN_MISMATCH);
    }

    get statusCellParsingFailed() {
        return this.hasStatus(RowStatus.ROW_STATUS_CELL_PARSING_FAILED);
    }

    get index() {
        return this.mIndex;
    }

    get columnNameToIndex() {
        throw 'ERROR: Not implemented';
    }

    get columnTypes() {
        throw 'ERROR: Not implemented';
    }

    get header() {
        throw 'ERROR: Not implemented';
    }

    get decoder() {
        throw 'ERROR: Not implemented';
    }

    hasStatus(rowStatus) {
        return Boolean(this.status & rowStatus);
    }

    async setIndex(index) { // eslint-disable-line
        throw 'ERROR: Not implemented';
    }

    async load() { // eslint-disable-line
        throw 'ERROR: Not implemented';
    }

    value(column, typed = false) {
        if (this.columnNameToIndex.hasOwnProperty(column)) {
            return typed ? this.valueByNameTyped(column) : this.valueByName(column);
        }

        const int = parseInt(column, 10);
        if (!isNaN(int) && int < this.header.length) {
            return typed ? this.valueByIndexTyped(int) : this.valueByIndex(int);
        }

        return null;
    }

    valueByIndex(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[index].str();
    }

    valueByIndexTyped(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[index].typed();
    }

    valueByIndexAsInt(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseInt(this.mGetters[index].str(), 10);
    }

    valueByIndexAsFloat(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseFloat(this.mGetters[index].str());
    }

    valueByName(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[this.columnNameToIndex[name]].str();
    }

    valueByNameTyped(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[this.columnNameToIndex[name]].typed();
    }

    valueByNameAsInt(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseInt(this.mGetters[this.columnNameToIndex[name]].str(), 10);
    }

    valueByNameAsFloat(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseFloat(this.mGetters[this.columnNameToIndex[name]].str());
    }

    forEach(itr) {
        for (let i = 0, n = this.header.length; i < n; ++i) {
            itr(this.valueByIndex(i), i, this.header[i].name);
        }
    }

    forEachTyped(itr) {
        for (let i = 0, n = this.header.length; i < n; ++i) {
            itr(this.valueByIndexTyped(i), i, this.header[i].name);
        }
    }

    _initializeColumnGetters() {
        this.mGetters = [];
        for (let i = 0, n = this.header.length; i < n; ++i) {
            const offset = 3 + 3 * i;
            let decoder = this.decoder;
            let dataPtr;
            let dataLength;

            // typedef struct
            // {
            //     byte *start;
            //     uint32 length;
            //     DataType type;
            // }
            // ParserCellInfo;
            const getBuffer = () => {
                if (i < this.mRowColumnCount) {
                    dataPtr = this.mChunk.layout[this.mRowOffset + offset];
                    dataLength = this.mChunk.layout[this.mRowOffset + offset + 1];
                    return decoder(this.mChunk.view, this.mChunk.dataOffset + dataPtr, dataLength);
                }
                return '';
            };
            let index = i;
            this.mGetters.push({
                str: getBuffer,
                typed: () => this.columnTypes[index].convert(getBuffer()),
            });
        }
    }
}

class DataChunkRow extends Row {
    constructor(header, chunk, encoding = 'utf8') {
        super();
        this.mHeader = header;
        this.mChunk = chunk;
        this.mDecoder = getDecoder(encoding);
        this.mIndex = -1;
        this.mGetters = null;

        this.mRowOffset = 0;
        this.mRowColumnCount = 0;
        this.mRowStatus = 0;

        this.mColumnNameToIndex = {};

        for (let i = 0, n = this.mHeader.length; i < n; ++i) {
            const column = this.mHeader[i];
            this.mColumnNameToIndex[column.name] = i;
        }

        this._initializeColumnGetters();
    }

    get columnNameToIndex() {
        return this.mColumnNameToIndex;
    }

    get columnTypes() {
        throw 'ERROR: Not implemented';
    }

    get header() {
        return this.mHeader;
    }

    get decoder() {
        return this.mDecoder;
    }

    get chunk() {
        return this.mChunk;
    }

    set chunk(value) {
        if (value !== this.mChunk) {
            this.mChunk = value;
            this.setIndex(0);
        }
    }

    setIndex(index) {
        this.mIndex = index;
        this.mRowOffset = this.mChunk.offsetList[index] / 4;
        this.mRowColumnCount = this.mChunk.layout[this.mRowOffset];
        this.mRowStatus = this.mChunk.layout[this.mRowOffset + 2];
    }

    async load() { // eslint-disable-line
        if (this.mChunk.loading) {
            await this.mChunk.loading;
        } else {
            await this.mChunk.load();
        }
    }
}

const supportsSharedMemory = (function() {
    try {
        new SharedArrayBuffer(1); // eslint-disable-line
        return true;
    } catch (e) {
        return false;
    }
})();

const sizeOf1KB = 1024;
const sizeOf1MB = sizeOf1KB * 1024;

const defaultConfig = {
    separator: ',',
    qualifier: '"',
    linebreak: '\n',
    firstRowHeader: true,
    maxRowSize: sizeOf1KB * 128,
    chunkSize: sizeOf1MB * 4,
    maxLoadedChunks: 32,
    encoding: 'utf8',
};

function combineTypedArrays(arrays) {
    const views = [];
    let length = 0;
    for (let i = 0; i < arrays.length; ++i) {
        if (arrays[i] instanceof Uint8Array) {
            views.push(arrays[i]);
        } else {
            views.push(new Uint8Array(arrays[i].buffer, arrays[i].byteOffset, arrays[i].byteLength));
        }
        length += arrays[i].byteLength;
    }

    const buffer = new ArrayBuffer(length);
    const view = new Uint8Array(buffer);

    let off = 0;
    for (let i = 0; i < views.length; ++i) {
        view.set(views[i], off);
        off += views[i].byteLength;
    }

    return buffer;
}

function combineBuffers(buffers) {
    const views = [];
    let length = 0;
    for (let i = 0; i < buffers.length; ++i) {
        views.push(new Uint8Array(buffers[i]));
        length += buffers[i].byteLength;
    }

    const buffer = new ArrayBuffer(length);
    const view = new Uint8Array(buffer);

    let off = 0;
    for (let i = 0; i < views.length; ++i) {
        view.set(views[i], off);
        off += views[i].byteLength;
    }

    return buffer;
}

function writeOptionsToBuffer(view, ptr, options) {
    let offset = 0;
    for (let i = 0, n = options.length; i < n; ++i) {
        view.setUint32(ptr + offset, options[i], true);
        offset += 4;
    }
    return offset;
}

function loadBlob(blob) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.readAsArrayBuffer(blob);
    });
}

function readRow(view, offset, result, config = defaultConfig) {
    const separator = config.separator.charCodeAt(0);
    const qualifier = config.qualifier.charCodeAt(0);
    const lineBreak = config.linebreak.charCodeAt(0);
    let fieldOffset = offset;
    let isInQuotes = false;
    let char;
    let i;
    for (i = offset; i < view.byteLength; ++i) {
        char = view.getUint8(i);
        if (char === qualifier) {
            if (!(i - fieldOffset) && !isInQuotes) {
                isInQuotes = true;
            } else if ((i - fieldOffset) && i + 1 < view.byteLength && view.getUint8(i + 1) === qualifier) {
                char = '"'.charCodeAt(0);
            } else if ((i - fieldOffset) && isInQuotes) {
                isInQuotes = false;
            } else {
                console.warn('WARNING: Malformed - found rogue qualifier'); // eslint-disable-line
            }
        } else if (char === separator && !isInQuotes) {
            result.push(new Uint8Array(view.buffer, fieldOffset, i - fieldOffset));
            fieldOffset = i + 1;
        } else if (char === lineBreak && !isInQuotes) {
            if (isInQuotes) {
                console.warn('WARNING: Malformed - qualifier field unterminated'); // eslint-disable-line
                isInQuotes = false;
            }

            result.push(new Uint8Array(view.buffer, fieldOffset, i - fieldOffset));
            return i + 1;
        }
    }

    if (i > fieldOffset) {
        result.push(new Uint8Array(view.buffer, fieldOffset, i - fieldOffset));
    }
    return i;
}

async function readHeader(file, config = defaultConfig) {
    const chunk = file.slice(0, Math.min(config.maxRowSize, file.size));
    const buffer = await chunk.load();

    const view = new DataView(buffer);
    const columns = [];
    const offset = readRow(view, 0, columns, config);
    const header = [];

    const rx = new RegExp(`^${config.qualifier}(.+(?=${config.qualifier}$))${config.qualifier}$`);
    for (let i = 0; i < columns.length; ++i) {
        const cleanValue = String.fromCharCode(...columns[i]).trim().replace(rx, '$1');
        header.push({
            name: config.firstRowHeader ? cleanValue : `Column${i}`,
            minLength: Number.MAX_SAFE_INTEGER,
            maxLength: Number.MIN_SAFE_INTEGER,
            emptyCount: 0,
            stringCount: 0,
            intCount: 0,
            floatCount: 0,
        });
    }

    return {
        header,
        offset: config.firstRowHeader ? offset : 0,
    };
}

async function sliceFile(file, start, config = defaultConfig) {
    const workerPool = WorkerPool.sharedInstance;
    const chunkSize = config.chunkSize;

    const promises = [];
    const offsets = [];
    let offset = start;
    while (offset < file.size) {
        offsets.push({
            start: offset,
            end: Math.min(offset + chunkSize, file.size),
        });
        offset += chunkSize;
    }

    const optionsBase = {
        linebreak: config.linebreak.charCodeAt(0),
        maxRowSize: config.maxRowSize,
        file,
    };

    for (let i = 0, n = offsets.length - 1; i < n; ++i) {
        const options = Object.assign({}, offsets[i], optionsBase, {
            index: i,
        });
        promises.push(workerPool.scheduleTask('calculateOffsets', options));
    }

    const results = await Promise.all(promises);
    const blobs = [];
    let i;
    for (i = 0; i < results.length; ++i) {
        offsets[results[i].index].end += results[i].offset;
        offsets[results[i].index + 1].start += results[i].offset;
    }

    for (i = 0; i < offsets.length; ++i) {
        blobs.push(file.slice(offsets[i].start, offsets[i].end));
    }

    return blobs;
}

async function analyzeBlobs(blobs, header, config = defaultConfig) {
    const workerPool = WorkerPool.sharedInstance;
    const promises = [];
    const optionsBase = {
        linebreak: config.linebreak.charCodeAt(0),
        separator: config.separator.charCodeAt(0),
        qualifier: config.qualifier.charCodeAt(0),
        columnCount: header.length,
        mode: PARSING_MODE.ANALYZE,
    };
    for (let i = 0, n = blobs.length; i < n; ++i) {
        const options = Object.assign({}, optionsBase, {
            blob: blobs[i],
            index: i,
        });
        promises.push(workerPool.scheduleTask('parseBlob', options));
    }

    const results = await Promise.all(promises);
    const chunks = new Array(blobs.length);
    const aggregated = {
        rowCount: 0,
        malformedRows: 0,
    };

    for (let i = 0; i < results.length; ++i) {
        chunks[results[i].index] = new DataChunk(blobs[results[i].index], header.length, results[i].stats.rowCount, config);
        aggregated.rowCount += results[i].stats.rowCount;
        aggregated.malformedRows += results[i].stats.malformedRows;

        const metaView = new Uint32Array(results[i].columns);
        for (let ii = 0, mi = 0; ii < header.length; ++ii, mi += 6) {
            header[ii].minLength = Math.min(header[ii].minLength, metaView[mi]);
            header[ii].maxLength = Math.max(header[ii].maxLength, metaView[mi + 1]);

            header[ii].intCount += metaView[mi + 2];
            header[ii].floatCount += metaView[mi + 3];
            header[ii].stringCount += metaView[mi + 4];
            header[ii].emptyCount += metaView[mi + 5];
        }
    }

    return {
        chunks,
        meta: aggregated,
    };
}

async function iterateBlobs(blobs, header, itr, config = defaultConfig) {
    const workerPool = WorkerPool.sharedInstance;
    const tasks = [];

    const optionsBase = {
        linebreak: config.linebreak.charCodeAt(0),
        separator: config.separator.charCodeAt(0),
        qualifier: config.qualifier.charCodeAt(0),
        columnCount: header.length,
        mode: PARSING_MODE.LOAD,
    };

    for (let i = 0, n = blobs.length; i < n; ++i) {
        const options = Object.assign({}, optionsBase, {
            blob: blobs[i],
            index: i,
        });
        tasks.push(options);
    }

    return await new Promise(resolve => {
        const row = new DataChunkRow(header, null, config.encoding);
        const results = {};
        let blobIndex = 0;
        let index = 0;
        const invokeIterator = result => {
            const chunk = DataChunk.fromLoadResult(result);
            row.chunk = chunk;
            for (let i = 0; i < chunk.rowCount; ++i) {
                row.setIndex(i);
                itr(row, index++);
            }
            chunk.unload();

            if (blobIndex >= blobs.length - 1) {
                resolve();
            }
        };

        const handleResult = result => {
            if (result.index === blobIndex) {
                invokeIterator(result);
                if (tasks.length) {
                    workerPool.scheduleTask('parseBlob', tasks.shift()).then(handleResult);
                }
                while (results.hasOwnProperty(++blobIndex)) {
                    invokeIterator(results[blobIndex]);
                    delete results[blobIndex];
                    if (tasks.length) {
                        workerPool.scheduleTask('parseBlob', tasks.shift()).then(handleResult);
                    }
                }
            } else {
                results[result.index] = result;
            }
        };

        for (let i = 0; i < workerPool.workers.length; ++i) {
            workerPool.scheduleTask('parseBlob', tasks.shift()).then(handleResult);
        }
    });
}

async function binaryChunksFromBlobs(blobs, header, config = defaultConfig) {
    const workerPool = WorkerPool.sharedInstance;
    const promises = [];
    const optionsBase = {
        linebreak: config.linebreak.charCodeAt(0),
        separator: config.separator.charCodeAt(0),
        qualifier: config.qualifier.charCodeAt(0),
        columnCount: header.length,
        mode: PARSING_MODE.BINARY,
    };
    for (let i = 0, n = blobs.length; i < n; ++i) {
        const options = Object.assign({}, optionsBase, {
            blob: blobs[i],
            index: i,
        });
        promises.push(workerPool.scheduleTask('parseBlob', options));
    }

    const results = await Promise.all(promises);
    const binaryHeader = {
        columns: [],
        names: {},
        rowCount: 0,
        rowLength: 0,
        dataLength: 0,
    };

    for (let i = 0; i < header.length; ++i) {
        binaryHeader.names[header[i].name] = binaryHeader.columns.length;
        binaryHeader.columns.push({
            name: header[i].name,
            length: 0,
            offset: 0,
            type: results[0].header.types[i],
        });
    }

    const orderedResults = [];
    for (let i = 0; i < results.length; ++i) {
        binaryHeader.rowCount += results[i].header.rowCount;
        for (let ii = 0; ii < header.length; ++ii) {
            binaryHeader.columns[ii].length = Math.max(binaryHeader.columns[ii].length, results[i].header.lengths[ii]);
        }
        orderedResults[results[i].index] = results[i];
    }

    let offset = 0;
    for (let i = 0; i < header.length; ++i) {
        binaryHeader.columns[results[0].header.order[i]].offset = offset;
        offset += binaryHeader.columns[results[0].header.order[i]].length;
    }
    binaryHeader.rowLength = offset;
    binaryHeader.dataLength = offset * binaryHeader.rowCount;
    binaryHeader.dataOffset = 0;

    return {
        header: binaryHeader,
        chunks: orderedResults,
    };
}

async function mergeChunksIntoBuffer(chunks, binaryHeader, config) {
    const workerPool = WorkerPool.sharedInstance;
    let buffer;
    if (config.output && config.output.buffer) {
        buffer = config.output.buffer;
        if (config.output.offset) {
            binaryHeader.dataOffset = config.output.offset;
        }
    } else {
        if (supportsSharedMemory) {
            buffer = new SharedArrayBuffer(binaryHeader.dataLength); // eslint-disable-line
        } else {
            buffer = new ArrayBuffer(binaryHeader.dataLength);
        }
    }

    const promises = [];
    let dataOffset = binaryHeader.dataOffset;
    if (supportsSharedMemory && buffer instanceof SharedArrayBuffer) { // eslint-disable-line
        for (let i = 0; i < chunks.length; ++i) {
            promises.push(workerPool.scheduleTask('mergeIntoBuffer', {
                buffer,
                binaryHeader,
                dataOffset,
                parsed: chunks[i],
            }), [ chunks[i].data ]);

            dataOffset += chunks[i].header.rowCount * binaryHeader.rowLength;
        }
        await Promise.all(promises);
    } else {
        const transferable = [buffer];
        for (let i = 0; i < chunks.length; ++i) {
            transferable.push(chunks[i].data);
        }

        buffer = await workerPool.scheduleTask('mergeParsedResults', {
            buffer,
            binaryHeader,
            dataOffset,
            parsed: chunks,
        }, transferable);
    }

    return {
        header: binaryHeader,
        data: buffer,
    };
}

var DataTools = /*#__PURE__*/Object.freeze({
    __proto__: null,
    supportsSharedMemory: supportsSharedMemory,
    sizeOf1KB: sizeOf1KB,
    sizeOf1MB: sizeOf1MB,
    defaultConfig: defaultConfig,
    combineTypedArrays: combineTypedArrays,
    combineBuffers: combineBuffers,
    writeOptionsToBuffer: writeOptionsToBuffer,
    loadBlob: loadBlob,
    readRow: readRow,
    readHeader: readHeader,
    sliceFile: sliceFile,
    analyzeBlobs: analyzeBlobs,
    iterateBlobs: iterateBlobs,
    binaryChunksFromBlobs: binaryChunksFromBlobs,
    mergeChunksIntoBuffer: mergeChunksIntoBuffer
});

/* handle running in node.js */
const kIsNodeJS$2 = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
const kRequire$1 = kIsNodeJS$2 ? module.require : null; // eslint-disable-line
const fs = kIsNodeJS$2 ? kRequire$1('fs') : null; // eslint-disable-line

class NodeChunk {
    constructor(file, start, end) {
        this.mFile = file;
        this.mStart = start;
        this.mEnd = end;
    }

    load() {
        return new Promise((resolve, reject) => {
            const length = this.mEnd - this.mStart;
            const arr = new Uint8Array(length);
            fs.read(this.mFile, arr, 0, length, this.mStart, (err, bytesRead) => {
                if (err || bytesRead !== length) {
                    reject(err);
                } else {
                    resolve(arr.buffer);
                }
            });
        });
    }
}

class WebChunk {
    constructor(blob) {
        this.mBlob = blob;
    }

    load() {
        return loadBlob(this.mBlob);
    }
}

class DataFile {
    static deserialize(description) {
        const result = Object.create(this.prototype);
        return Object.assign(result, description);
    }

    static deserializeBlob(blob) {
        if (kIsNodeJS$2) {
            return new NodeChunk(blob.mFile, blob.mStart, blob.mEnd);
        }
        return new WebChunk(blob.mBlob);
    }

    constructor(file) {
        this.mFile = file;
        this.mByteLength = 0;

        if (kIsNodeJS$2) {
            const stat = fs.fstatSync(this.mFile);
            this.mByteLength = stat.size;
        } else {
            this.mByteLength = this.mFile.size;
        }
    }

    get byteLength() {
        return this.mByteLength;
    }

    get size() {
        return this.mByteLength;
    }

    slice(start, end) {
        if (kIsNodeJS$2) {
            return new NodeChunk(this.mFile, start, end);
        }

        const blob = this.mFile.slice(start, end);
        return new WebChunk(blob);
    }
}

class TableRow extends Row {
    constructor(table) {
        super();
        this.mTable = table;
        this.mChunkInfo = null;

        this._initializeColumnGetters();
    }

    get table() {
        return this.mTable;
    }

    get chunkInfo() {
        return this.mChunkInfo;
    }

    get columnNameToIndex() {
        return this.mTable.columnNameToIndex;
    }

    get columnTypes() {
        return this.mTable.columnTypes;
    }

    get header() {
        return this.mTable.header;
    }

    get decoder() {
        return this.mTable.decoder;
    }

    async setIndex(index) {
        if (index !== this.mIndex) {
            this.mIndex = index;
            if (!this.mChunkInfo || this.mIndex < this.mChunkInfo.start || this.mIndex >= this.mChunkInfo.end) {
                this.mChunkInfo = this._getChunkInfoForRow(this.mIndex);
                this.mChunk = this.mTable.chunks[this.mChunkInfo.index];
                await this.load();
            }

            // typedef struct
            // {
            //     uint32 columnCount;
            //     uint32 length;
            //     uint32 status;
            // }
            // ParserRowInfo;
            this.mRowOffset = this.mChunk.offsetList[this.mIndex - this.mChunkInfo.start] / 4;
            this.mRowColumnCount = this.mChunk.layout[this.mRowOffset];
            this.mRowStatus = this.mChunk.layout[this.mRowOffset + 2];
        }
        return this;
    }

    async load() {
        if (this.mChunk && !this.mChunk.loaded) {
            await this.mTable._loadChunk(this.mChunk);
        }
    }

    _getChunkInfoForRow(index) {
        let i = Math.floor(this.mTable.chunks.length * (index / this.mTable.rowCount));

        while (i < this.mTable.chunks.length && index >= this.mTable.rowMap[i]) {
            ++i;
        }

        while (i > 0 && index < this.mTable.rowMap[i - 1]) {
            --i;
        }

        return {
            index: i,
            start: i === 0 ? 0 : this.mTable.rowMap[i - 1],
            end: this.mTable.rowMap[i],
        };
    }
}

const kStringType = {
    bin: 0,
    name: 'string',
    convert: str => str,
};

const kFloatType = {
    bin: 1,
    name: 'float',
    convert: str => parseFloat(str),
};

const kIntType = {
    bin: 2,
    name: 'int',
    convert: str => parseInt(str, 10),
};

const kTypes = {
    'string': kStringType,
    'float': kFloatType,
    'int': kIntType,
};

class Table {
    static async fromFile(file, configuration = null) {
        const dataFile = new DataFile(file);
        const config = Object.freeze(Object.assign({}, defaultConfig, configuration));
        const {header, offset} = await readHeader(dataFile, config);
        const blobs = await sliceFile(dataFile, offset, config);
        const analyzed = await analyzeBlobs(blobs, header, config);

        return new Table(header, analyzed.chunks, analyzed.meta, config);
    }

    static async fromURL(url, configuration = null) {
        const opts = Object.assign({}, defaultConfig, configuration);
        opts.toString();
        throw 'Not implemented yet';
    }

    static async fromString(str, configuration = null) {
        const blob = new Blob([str]);
        return await this.fromFile(blob, configuration);
    }

    constructor(header, chunks, meta, config) {
        this.mHeader = header;
        this.mChunks = chunks;
        this.mMeta = meta;
        this.mConfig = config;
        this.mRowMap = this._generateRowsMap(this.mChunks);
        this.mLoadedChunks = [];
        this.mColumnTypes = [];
        this.mColumnNameToIndex = {};
        this.mDecoder = getDecoder(this.mConfig.encoding);

        for (let i = 0, n = this.mHeader.length; i < n; ++i) {
            const column = this.mHeader[i];
            this.mColumnNameToIndex[column.name] = i;
            this.setColumnType(i);
        }
    }

    get rowCount() {
        return this.mMeta.rowCount;
    }

    get meta() {
        return this.mMeta;
    }

    get config() {
        return this.mConfig;
    }

    get header() {
        return this.mHeader;
    }

    get chunks() {
        return this.mChunks;
    }

    get rowMap() {
        return this.mRowMap;
    }

    get columnTypes() {
        return this.mColumnTypes;
    }

    get columnNameToIndex() {
        return this.mColumnNameToIndex;
    }

    get decoder() {
        return this.mDecoder;
    }

    setColumnType(column, type = null) {
        if (type !== null && !kTypes.hasOwnProperty(type)) {
            throw `Unknown type ${type}`;
        }

        let index;
        if (this.mColumnNameToIndex.hasOwnProperty(column)) {
            index = this.mColumnNameToIndex[column];
        } else {
            index = parseInt(column, 10);
            if (isNaN(index) || index < 0 || index >= this.mHeader.length) {
                throw `Unknown column: ${column}`;
            }
        }

        if (type === null) {
            const col = this.mHeader[index];
            const rowCount = this.rowCount - col.emptyCount;
            if (col.stringCount > col.intCount + col.floatCount) {
                this.mColumnTypes.push(Object.assign({}, kStringType, {
                    certainty: col.stringCount / rowCount,
                }));
            } else if (col.floatCount !== 0) {
                this.mColumnTypes.push(Object.assign({}, kFloatType, {
                    certainty: (col.floatCount + col.intCount) / rowCount,
                }));
            } else {
                this.mColumnTypes.push(Object.assign({}, kIntType, {
                    certainty: col.intCount / rowCount,
                }));
            }
        } else {
            this.mColumnTypes[index] = Object.assign({}, kTypes[type], {
                certainty: 1.0,
            });
        }
    }

    async getRow(i = 0) {
        const row = new TableRow(this);
        return await row.setIndex(i);
    }

    async forEach(itr) {
        const row = new TableRow(this);
        const chunkCount = this.mChunks.length;
        const loading = [];
        let loadIndex;
        for (loadIndex = 0; loadIndex < this.mConfig.maxLoadedChunks && loadIndex < chunkCount; ++loadIndex) {
            loading.push(this._loadChunk(this.mChunks[loadIndex]));
        }

        for (let i = 0, n = this.rowCount; i < n; ++i) {
            if (row.chunkInfo && i >= row.chunkInfo.end && loadIndex < chunkCount) {
                this._loadChunk(this.mChunks[loadIndex++]);
            }
            await row.setIndex(i);
            itr(row, i);
        }
    }

    async _loadChunk(chunk) {
        if (chunk.loading) {
            return await chunk.loading;
        }

        if (this.mLoadedChunks.length >= this.mConfig.maxLoadedChunks) {
            this.mLoadedChunks.shift().unload();
        }
        this.mLoadedChunks.push(chunk);
        return await chunk.load(this.mConfig);
    }

    _generateRowsMap(chunks) {
        const result = [];
        let count = 0;
        for (let i = 0; i < chunks.length; ++i) {
            count += chunks[i].rowCount;
            result.push(count);
        }
        return result;
    }

    _binaryColumnTypes() {
        return this.mColumnTypes.map(type => type.bin);
    }

    _binaryLengths() {
        const result = {
            columnLengths: [],
            columnOffsets: [],
            rowLength: 0,
        };

        let size;
        for (let i = 0, n = this.mColumnTypes.length; i < n; ++i) {
            if (this.mColumnTypes[i].bin === kStringType.bin) {
                size = (Math.min(this.mHeader[i].maxLength, 255) + 4) & ~0x03;
            } else {
                size = 4;
            }
            result.columnLengths.push(size);
            result.columnOffsets.push(result.rowLength);
            result.rowLength += size;
        }

        return result;
    }
}

var kRequire$2 =
    typeof module !== 'undefined' && typeof module.require === 'function' && module.require || // eslint-disable-line
    typeof __non_webpack_require__ === 'function' && __non_webpack_require__ || // eslint-disable-line
    typeof require === 'function' && require || // eslint-disable-line
    null; // eslint-disable-line

var WorkerClass$1 = null;

if (kRequire$2) {
    try { WorkerClass$1 = kRequire$2('worker_threads').Worker; } catch(e) {} // eslint-disable-line
}

function decodeBase64$2(base64, enableUnicode) {
    return Buffer.from(base64, 'base64').toString(enableUnicode ? 'utf16' : 'utf8');
}

function createBase64WorkerFactory$3(base64, sourcemapArg, enableUnicodeArg) {
    var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
    var enableUnicode = enableUnicodeArg === undefined ? false : enableUnicodeArg;
    var source = decodeBase64$2(base64, enableUnicode);
    var start = source.indexOf('\n', 10) + 1;
    var body = source.substring(start) + (sourcemap ? '\/\/# sourceMappingURL=' + sourcemap : '');
    return function WorkerFactory(options) {
        return new WorkerClass$1(body, Object.assign({}, options, { eval: true }));
    };
}

function decodeBase64$1$1(base64, enableUnicode) {
    var binaryString = atob(base64);
    if (enableUnicode) {
        var binaryView = new Uint8Array(binaryString.length);
        for (var i = 0, n = binaryString.length; i < n; ++i) {
            binaryView[i] = binaryString.charCodeAt(i);
        }
        return String.fromCharCode.apply(null, new Uint16Array(binaryView.buffer));
    }
    return binaryString;
}

function createBase64WorkerFactory$1$1(base64, sourcemapArg, enableUnicodeArg) {
    var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
    var enableUnicode = enableUnicodeArg === undefined ? false : enableUnicodeArg;
    var source = decodeBase64$1$1(base64, enableUnicode);
    var start = source.indexOf('\n', 10) + 1;
    var body = source.substring(start) + (sourcemap ? '\/\/# sourceMappingURL=' + sourcemap : '');
    var blob = new Blob([body], { type: 'application/javascript' });
    var url = URL.createObjectURL(blob);
    return function WorkerFactory(options) {
        return new Worker(url, options);
    };
}

const kIsNodeJS$3 = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';

function isNodeJS$1() {
    return kIsNodeJS$3;
}

function createBase64WorkerFactory$2$1(base64, sourcemapArg, enableUnicodeArg) {
    if (isNodeJS$1()) {
        return createBase64WorkerFactory$3(base64, sourcemapArg, enableUnicodeArg);
    }
    return createBase64WorkerFactory$1$1(base64, sourcemapArg, enableUnicodeArg);
}

var WorkerFactory$1 = createBase64WorkerFactory$2$1('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', null, false);
/* eslint-enable */

var workloadWASM = "data:application/wasm;base64,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";

const kIsNodeJS$1$1 = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
const kRequire$1$1 = kIsNodeJS$1$1 ? module.require : null; // eslint-disable-line

/**
 * Utility to estimate the number of usable cores to perform data processing in node.js and the browser.
 *
 * In node.js, it uses the code from [this gist](https://gist.github.com/brandon93s/a46fb07b0dd589dc34e987c33d775679) to
 * query the number of CPUs on the system. It can be configured to run the same estimation as in the browser.
 *
 * In the browser, takes ~2 seconds to estimate the number of CPUs, uses WASM (when available) to perform the estimation.
 *
 * Returns a {@link Promise} that resolves to a {@link WebCPUResult}.
 *
 * ### Installation
 * ```
 * yarn add webcpu
 * ```
 * or
 * ```
 * npm install webcpu
 * ```
 *
 * ### Usage
 * In Web:
 * ```
 * import {WebCPU} from 'webcpu';
 *
 * WebCPU.detectCPU().then(result => {
 *     console.log(`Reported Cores: ${result.reportedCores}`);
 *     console.log(`Estimated Idle Cores: ${result.estimatedIdleCores}`);
 *     console.log(`Estimated Physical Cores: ${result.estimatedPhysicalCores}`);
 * });
 * ```
 *
 * In Node:
 * ```
 * const WebCPU = require('webcpu/dist/umd/webcpu').WebCPU;
 *
 * WebCPU.detectCPU().then(result => {
 *     console.log(`Reported Cores: ${result.reportedCores}`);
 *     console.log(`Estimated Idle Cores: ${result.estimatedIdleCores}`);
 *     console.log(`Estimated Physical Cores: ${result.estimatedPhysicalCores}`);
 * });
 * ```
 *
 * ### Description
 * The core estimation is affected by other tasks in the system, usually the OS scheduler is efficient enough that
 * light tasks (playing music, idle programs, background updates, etc) are evenly distributed across cores and so they
 * will not affect the result of this estimation. Heavy tasks do have an effect in the results of the estimation, it is
 * recommended that you avoid performing heavy tasks while the estimation is running, it is considered good practice to
 * run the estimation periodically to compensate for user's CPU workloads and always keep an optimal number of
 * operational cores.
 *
 * The estimation is performed by running a mathematical operation in a loop for a predefined amount of time. Modern
 * CPUs run this task simultaneously across physical cores and usually each core completes a very similar number of
 * operations, once hyper threading (or task scheduling) kicks in, a few cores must share their cycles among
 * threads running. By detecting the changes in operations completed by each thread, it is possible to estimate the
 * number of cores in the system.
 *
 * The current algorithm returns bad estimations for CPUs with asymmetric cores (usually mobile ARM chips) because, as
 * explained above, it detects the changes in number of operations between threads. Asymmetric cores will complete
 * a different number of operations depending on the power of the core the task is scheduled on. Although the returned
 * estimations will be incorrect, they are safe to use to spawn threads.
 *
 * This utility DOES NOT estimate logical cores, instead it uses `navigator.hardwareConcurrency` (if available) or simply
 * returns the same number as the estimated physical cores.
 *
 * ## Methods
 */
class WebCPU {
    /**
     * Estimates the number of CPUs in this machine.
     * @param {boolean=} hardcore - Engages hardcore mode, which kills all the workers after every test.
     * @param {boolean=} estimateInNode - If `true`, forces core estimation in Node.js rather than querying the system.
     * @returns {Promise<WebCPUResult>} - Result of the estimation.
     */
    static async detectCPU(hardcore = false, estimateInNode = false) {
        let reportedCores;

        if (kIsNodeJS$1$1) {
            /* we are running in node, emulate the response */
            /* eslint-disable */
            const os = kRequire$1$1('os');
            const childProcess = kRequire$1$1('child_process');

            reportedCores = kRequire$1$1('os').cpus().length;

            if (!estimateInNode) {
                /* code taken from https://gist.github.com/brandon93s/a46fb07b0dd589dc34e987c33d775679 */
                const exec = function exec(command) {
                    return childProcess.execSync(command, {encoding: 'utf8'});
                };

                const platform = os.platform();
                let amount = 0;

                if (platform === 'linux') {
                    const output = exec('lscpu -p | egrep -v "^#" | sort -u -t, -k 2,4 | wc -l');
                    amount = parseInt(output.trim(), 10);
                } else if (platform === 'darwin') {
                    const output = exec('sysctl -n hw.physicalcpu_max');
                    amount = parseInt(output.trim(), 10);
                } else if (platform === 'windows') {
                    const output = exec('WMIC CPU Get NumberOfCores');
                    amount = output.split(os.EOL)
                        .map(function parse(line) {
                            return parseInt(line)
                        })
                        .filter(function numbers(value) {
                            return !isNaN(value)
                        })
                        .reduce(function add(sum, number) {
                            return sum + number
                        }, 0);
                }

                if (amount) {
                    return {
                        reportedCores: reportedCores,
                        estimatedIdleCores: amount,
                        estimatedPhysicalCores: amount,
                    }
                }
            }
            /* eslint-enable */
        } else {
            reportedCores = navigator.hardwareConcurrency ? navigator.hardwareConcurrency : null;
        }

        const maxCoresToTest = reportedCores ? reportedCores : Number.MAX_SAFE_INTEGER;
        const workers = [];
        const loops = 2;
        let baseStats;

        let wasmModule = null;
        if (WebAssembly) {
            if (WebAssembly.compileStreaming) {
                wasmModule = await WebAssembly.compileStreaming(fetch(workloadWASM));
            } else if (WebAssembly.compile) {
                if (kIsNodeJS$1$1) {
                    const buffer = Buffer.from(workloadWASM.substr(workloadWASM.indexOf(',') + 1), 'base64');
                    wasmModule = await WebAssembly.compile(buffer);
                } else {
                    const result = await fetch(workloadWASM);
                    const buffer = await result.arrayBuffer();
                    wasmModule = await WebAssembly.compile(buffer);
                }
            }
        }

        workers.push(await this._initWorker(wasmModule));
        await this._testWorkers(workers, loops);
        baseStats = await this._testWorkers(workers, loops);
        // console.log(baseStats);

        if (hardcore) {
            this._killWorkers(workers);
        }

        let oddCores = 0;
        let thresholdCount = 0;
        let threadCount = 0;
        while (threadCount < maxCoresToTest) {
            ++threadCount;
            const promises = [];
            for (let i = workers.length; i < threadCount; ++i) {
                promises.push(this._initWorker(wasmModule).then(worker => workers.push(worker)));
            }
            await Promise.all(promises);
            promises.length = 0;

            const stats = await this._testWorkers(workers, loops);
            if (!this._areAllCoresValid(baseStats, stats, 0.9)) {
                --threadCount;
                ++thresholdCount;
                if (thresholdCount > 3) {
                    if (threadCount % 2 && ++oddCores < 2) {
                        --threadCount;
                        thresholdCount = 0;
                        this._killWorkers([workers.pop()]);
                    } else {
                        this._killWorkers(workers);
                        break;
                    }
                }
            } else if (thresholdCount) {
                --threadCount;
                --thresholdCount;
            }

            if (hardcore) {
                this._killWorkers(workers);
            }
        }

        let physicalCores;
        if (reportedCores && threadCount < reportedCores) {
            physicalCores = Math.floor(reportedCores / 2);
        } else {
            physicalCores = threadCount;
        }

        return {
            reportedCores: reportedCores,
            estimatedIdleCores: threadCount,
            estimatedPhysicalCores: physicalCores,
        };
    }

    /**
     * Kills all the workers in the specified array.
     * @param {Worker[]} workers - Workers to kill
     * @private
     */
    static _killWorkers(workers) {
        while (workers.length) {
            workers.pop().terminate();
        }
    }

    /**
     * Run tests in the specified workers and repeats the test for the specified number of loops. This function performs
     * and ignores the results of 5 extra loops. This is to mitigate the fact that some processor and OS combinations
     * use lazy loading.
     * @param {Worker[]} workers - The workers in which the test will run.
     * @param {number} loops - The number of times the tests will be repeated.
     * @returns {Promise<Array>}
     * @private
     */
    static async _testWorkers(workers, loops) {
        const stats = [];
        const promises = [];
        const extraLoops = 2;
        const startTime = Date.now() + workers.length * 3;
        let results;
        for (let n = 0; n < loops + extraLoops; ++n) {
            for (let i = 0; i < workers.length; ++i) {
                promises.push(this._computeWorker(workers[i], i, startTime));
            }
            results = await Promise.all(promises);
            if (n >= extraLoops) {
                this._addResults(stats, results);
            }
            promises.length = 0;
        }

        this._aggregateResults(stats, loops);

        return stats;
    }

    /**
     * Adds the results from a test loop to the specified stats array.
     * @param {Array} stats - Stats array to save the results in
     * @param {Array} results - The results of a test loop.
     * @private
     */
    static _addResults(stats, results) {
        for (let i = 0; i < results.length; ++i) {
            if (!stats[results[i].id]) {
                stats[results[i].id] = {
                    elapsed: 0,
                    iterations: 0,
                };
            }
            stats[results[i].id].elapsed += results[i].elapsed;
            stats[results[i].id].iterations += results[i].iterations;
        }
    }

    /**
     * Aggregates all the results added to a stats object.
     * This function effectively normalizes the data passed to it.
     * @param {Array} stats - Stats array no aggregate.
     * @param {number} loops - The number of times the test ran.
     * @returns {Array}
     * @private
     */
    static _aggregateResults(stats, loops) {
        for (let i = 0; i < stats.length; ++i) {
            stats[i].elapsed /= loops;
            stats[i].iterations /= loops;
        }

        return stats;
    }

    /**
     * Starts the computation task in the specified worker with the specified id.
     * This method also accepts a start time (in ms, usually Date.now() + ms_to delay), useful to synchronize the start
     * time of the computation in multiple threads.
     * @param {Worker} worker - The worker in which the computation will be started.
     * @param {number} id - The id of this thread.
     * @param {number} startTime - A time in the future when the computations should start.
     * @returns {Promise<any>}
     * @private
     */
    static _computeWorker(worker, id, startTime) {
        const addListener = worker.addEventListener || worker.on;
        const removeListener = worker.removeEventListener || worker.off;
        return new Promise(resolve => {
            const handler = e => {
                removeListener.call(worker, 'message', handler);
                resolve(e.data || e);
            };
            addListener.call(worker, 'message', handler);
            worker.postMessage({type: 'workload', id, startTime});
        });
    }

    /**
     * Allocates and initializes a worker.
     * @param {WebAssembly.Module=} wasm - The WASM module, if available, that contains the workload.
     * @returns {Promise<any>}
     * @private
     */
    static _initWorker(wasm = null) {
        return new Promise((resolve, reject) => {
            const worker = new WorkerFactory$1();

            const addListener = worker.addEventListener || worker.on;
            const removeListener = worker.removeEventListener || worker.off;

            const handler = e => {
                removeListener.call(worker, 'message', handler);
                const message = e.data || e;
                if (message === 'success') {
                    resolve(worker);
                } else {
                    worker.terminate();
                    reject();
                }
            };
            addListener.call(worker, 'message', handler);
            worker.postMessage({type: 'init', wasm});
        });
    }

    /**
     * Estimates if all the cores, based on the results in the provided `stats` object, are running at the same time and
     * performing the same number of operations.
     * @param {Array} baseStats - The stats resulting from running tests loops on a single core.
     * @param {Array} stats - The stats of multiple cores to test against.
     * @param {number} threshold - Threshold, between 0 ans 1, that defines when a core is not considered physical.
     * @returns {boolean}
     * @private
     */
    static _areAllCoresValid(baseStats, stats, threshold) {
        let iterations = 0;
        stats.sort((a, b) => b.iterations - a.iterations);
        for (let i = 0; i < stats.length; ++i) {
            iterations += stats[i].iterations;
        }

        // console.log(stats);

        const local = stats[stats.length - 1].iterations / stats[0].iterations;
        const global = iterations / (baseStats[0].iterations * stats.length);
        const combined = local * 0.85 + global * 0.15;
        // console.log(`threads:${stats.length} local:${local} global:${global} estimated:${combined}\n`);

        return combined >= threshold;
    }
}

var wasmData = "data:application/wasm;base64,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";

const RowStatus$1 = {
    ROW_STATUS_OK: 0,
    ROW_STATUS_DANGLING_QUALIFIER: 1,
    ROW_STATUS_COLUMN_MISMATCH: 2,
    ROW_STATUS_CELL_PARSING_FAILED: 4,
};

class Row$1 {
    static get states() {
        return RowStatus$1;
    }

    constructor() {
        this.mIndex = -1;
        this.mChunk = null;
        this.mGetters = null;

        this.mRowOffset = 0;
        this.mRowColumnCount = 0;
        this.mRowStatus = RowStatus$1.ROW_STATUS_OK;
    }

    get status() {
        return this.mRowStatus;
    }

    get statusDanglingQualifier() {
        return this.hasStatus(RowStatus$1.ROW_STATUS_DANGLING_QUALIFIER);
    }

    get statusColumnMismatch() {
        return this.hasStatus(RowStatus$1.ROW_STATUS_COLUMN_MISMATCH);
    }

    get statusCellParsingFailed() {
        return this.hasStatus(RowStatus$1.ROW_STATUS_CELL_PARSING_FAILED);
    }

    get index() {
        return this.mIndex;
    }

    get columnNameToIndex() {
        throw 'ERROR: Not implemented';
    }

    get columnTypes() {
        throw 'ERROR: Not implemented';
    }

    get header() {
        throw 'ERROR: Not implemented';
    }

    get decoder() {
        throw 'ERROR: Not implemented';
    }

    hasStatus(rowStatus) {
        return Boolean(this.status & rowStatus);
    }

    async setIndex(index) { // eslint-disable-line
        throw 'ERROR: Not implemented';
    }

    async load() { // eslint-disable-line
        throw 'ERROR: Not implemented';
    }

    value(column, typed = false) {
        if (this.columnNameToIndex.hasOwnProperty(column)) {
            return typed ? this.valueByNameTyped(column) : this.valueByName(column);
        }

        const int = parseInt(column, 10);
        if (!isNaN(int) && int < this.header.length) {
            return typed ? this.valueByIndexTyped(int) : this.valueByIndex(int);
        }

        return null;
    }

    valueByIndex(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[index].str();
    }

    valueByIndexTyped(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[index].typed();
    }

    valueByIndexAsInt(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseInt(this.mGetters[index].str(), 10);
    }

    valueByIndexAsFloat(index) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseFloat(this.mGetters[index].str());
    }

    valueByName(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[this.columnNameToIndex[name]].str();
    }

    valueByNameTyped(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return this.mGetters[this.columnNameToIndex[name]].typed();
    }

    valueByNameAsInt(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseInt(this.mGetters[this.columnNameToIndex[name]].str(), 10);
    }

    valueByNameAsFloat(name) {
        if (!this.mChunk || !this.mChunk.loaded) {
            return null;
        }
        return parseFloat(this.mGetters[this.columnNameToIndex[name]].str());
    }

    forEach(itr) {
        for (let i = 0, n = this.header.length; i < n; ++i) {
            itr(this.valueByIndex(i), i, this.header[i].name);
        }
    }

    forEachTyped(itr) {
        for (let i = 0, n = this.header.length; i < n; ++i) {
            itr(this.valueByIndexTyped(i), i, this.header[i].name);
        }
    }

    _initializeColumnGetters() {
        this.mGetters = [];
        for (let i = 0, n = this.header.length; i < n; ++i) {
            const offset = 3 + 3 * i;
            let decoder = this.decoder;
            let dataPtr;
            let dataLength;

            // typedef struct
            // {
            //     byte *start;
            //     uint32 length;
            //     DataType type;
            // }
            // ParserCellInfo;
            const getBuffer = () => {
                if (i < this.mRowColumnCount) {
                    dataPtr = this.mChunk.layout[this.mRowOffset + offset];
                    dataLength = this.mChunk.layout[this.mRowOffset + offset + 1];
                    return decoder(this.mChunk.view, this.mChunk.dataOffset + dataPtr, dataLength);
                }
                return '';
            };
            let index = i;
            this.mGetters.push({
                str: getBuffer,
                typed: () => this.columnTypes[index].convert(getBuffer()),
            });
        }
    }
}

class BinaryRow extends Row$1 {
    constructor(table) {
        super();
        this.mTable = table;
        this.mChunk = { loaded: true };

        this._initializeColumnGetters();
    }

    get table() {
        return this.mTable;
    }

    get columnNameToIndex() {
        return this.mTable.columnNameToIndex;
    }

    get columnTypes() {
        return this.mTable.columnTypes;
    }

    get header() {
        return this.mTable.header.columns;
    }

    get decoder() {
        return this.mTable.decoder;
    }

    setIndex(index) { // eslint-disable-line
        this.mRowOffset = this.mTable.header.dataOffset + this.mTable.header.rowLength * index;
        return this;
    }

    async load() { // eslint-disable-line
        return true;
    }

    _initializeColumnGetters() {
        this.mGetters = [];
        for (let i = 0, n = this.header.length; i < n; ++i) {
            const offset = this.header[i].offset;

            let getData;

            switch (this.header[i].type) {
                case 0: {
                    const decoder = this.decoder;
                    let dataLength;
                    getData = () => {
                        dataLength = this.mTable.view.getUint8(this.mRowOffset + offset);
                        return decoder(this.mTable.view, this.mRowOffset + offset + 1, dataLength);
                    };
                }
                    break;

                case 1:
                    getData = () => this.mTable.view.getInt32(this.mRowOffset + offset, true);
                    break;

                case 2:
                    getData = () => this.mTable.view.getFloat32(this.mRowOffset + offset, true);
                    break;

                default:
                    throw `ERROR: Unknown bin type (${this.header[i].type})`;
            }

            this.mGetters.push({
                str: getData,
                typed: getData,
            });
        }
    }
}

class BinaryTable {
    static async fromFile(file, configuration = null) {
        const dataFile = new DataFile(file);
        const config = Object.freeze(Object.assign({}, defaultConfig, configuration));
        const {header, offset} = await readHeader(dataFile, config);
        const blobs = await sliceFile(dataFile, offset, config);
        const result = await binaryChunksFromBlobs(blobs, header, config);
        const binary = await mergeChunksIntoBuffer(result.chunks, result.header, config);

        return new BinaryTable(binary.header, binary.data, config);
    }

    static async fromURL(url, configuration = null) {
        const opts = Object.assign({}, defaultConfig, configuration);
        opts.toString();
        throw 'Not implemented yet';
    }

    static async fromString(str, configuration = null) {
        const blob = new Blob([str]);
        return await this.fromFile(blob, configuration);
    }

    constructor(header, buffer, config) {
        this.mHeader = header;
        this.mBuffer = buffer;
        this.mConfig = config;
        this.mView = new DataView(this.mBuffer);
        this.mDecoder = getDecoder(this.mConfig.encoding);
        this.mColumnTypes = [];
        this.mMeta = {
            rowCount: this.mHeader.rowCount,
            malformedRows: 0,
        };

        for (let i = 0; i < this.mHeader.columns.length; ++i) {
            switch (this.mHeader.columns[i].type) {
                case 0:
                    this.mColumnTypes.push({
                        bin: 0,
                        name: 'string',
                    });
                    break;

                case 1:
                    this.mColumnTypes.push({
                        bin: 1,
                        name: 'int',
                    });
                    break;

                case 2:
                    this.mColumnTypes.push({
                        bin: 2,
                        name: 'float',
                    });
                    break;

                default:
                    throw `ERROR: Unknown bin type (${this.mHeader.columns[i].type})`;
            }
        }
    }

    get buffer() {
        return this.mBuffer;
    }

    get view() {
        return this.mView;
    }

    get rowCount() {
        return this.mHeader.rowCount;
    }

    get config() {
        return this.mConfig;
    }

    get header() {
        return this.mHeader;
    }

    get meta() {
        return this.mMeta;
    }

    get columnTypes() {
        return this.mColumnTypes;
    }

    get columnNameToIndex() {
        return this.mHeader.names;
    }

    get decoder() {
        return this.mDecoder;
    }

    getRow(i = 0) {
        const row = new BinaryRow(this);
        return row.setIndex(i);
    }

    forEach(itr) {
        const row = new BinaryRow(this);
        for (let i = 0, n = this.rowCount; i < n; ++i) {
            row.setIndex(i);
            itr(row, i);
        }
    }
}

/* handle running in node.js */
const kIsNodeJS$4 = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';

const _dekkai = (function() {
    const initializedSymbol = Symbol('dekkai::initialized');

    class dekkai {
        constructor() {
            this[initializedSymbol] = null;
        }

        get DataFile() {
            return DataFile;
        }

        get DataTools() {
            return DataTools;
        }

        get WorkerPool() {
            return WorkerPool;
        }

        async init(workerCount = -1) {
            if (!this[initializedSymbol]) {
                this[initializedSymbol] = new Promise(async done => {
                    let threads = workerCount;
                    if (threads < 1 || isNaN(threads)) {
                        const webCPUResult = await WebCPU.detectCPU();
                        threads = webCPUResult.estimatedPhysicalCores;
                    }

                    let wasmModule = null;
                    if (WebAssembly) {
                        if (WebAssembly.compileStreaming) {
                            wasmModule = await WebAssembly.compileStreaming(fetch(wasmData));
                        } else if (WebAssembly.compile) {
                            if (kIsNodeJS$4) {
                                const buffer = Buffer.from(wasmData.substr(wasmData.indexOf(',') + 1), 'base64');
                                wasmModule = await WebAssembly.compile(buffer);
                            } else {
                                const result = await fetch(wasmData);
                                const buffer = await result.arrayBuffer();
                                wasmModule = await WebAssembly.compile(buffer);
                            }
                        }
                    }

                    const promises = [];
                    for (let i = 0; i < threads; ++i) {
                        const promise = WorkerPool.sharedInstance.addWorker(new WorkerFactory(), {
                            type: 'init',
                            options: {
                                id: i,
                                wasm: wasmModule,
                            },
                        });
                        promises.push(promise);
                    }
                    await Promise.all(promises);
                    done(this);
                });
            }
            return await this[initializedSymbol];
        }

        terminate() {
            WorkerPool.sharedInstance.killWorkers();
            this[initializedSymbol] = null;
        }

        async iterateLocalFile(file, itr, options = null) {
            await this.init();
            const dataFile = new DataFile(file);
            const config = Object.freeze(Object.assign({}, defaultConfig, options));
            const {header, offset} = await readHeader(dataFile, config);
            const blobs = await sliceFile(dataFile, offset, config);
            await iterateBlobs(blobs, header, itr, config);
        }

        async binaryFromLocalFile(file, options = null) {
            await this.init();
            return await BinaryTable.fromFile(file, options);
        }

        async binaryFromURL(url, options = null) {
            await this.init();
            return await BinaryTable.fromURL(url, options);
        }

        async binaryFromString(str, options = null) {
            await this.init();
            return await BinaryTable.fromString(str, options);
        }

        async tableFromLocalFile(file, options = null) {
            await this.init();
            return await Table.fromFile(file, options);
        }

        async tableFromURL(url, options = null) {
            await this.init();
            return await Table.fromURL(url, options);
        }

        async tableFromString(str, options = null) {
            await this.init();
            return await Table.fromString(str, options);
        }
    }

    return new dekkai(); // eslint-disable-line
})();

export default _dekkai;
//# sourceMappingURL=dekkai.js.map
